import ICompetitor from '@/models/interfaces/ICompetitor';

export default class Competitor implements ICompetitor {
  name: string;

  surname: string;

  notes: string;

  novice: boolean;

  active: boolean;

  id: string;

  noviceYear: number | null;

  constructor(name: string, surname: string, id: string, novice: boolean, active: boolean, notes: string, noviceYear: number | null) {
    this.name = name;
    this.surname = surname;
    this.novice = novice;
    this.active = active;
    this.notes = notes;
    this.id = id;
    this.noviceYear = noviceYear;
  }
}
